/**
 * Native healthcare-ui HTTP client — no HMS shell dependency.
 * Reuses the same axios instance as the rest of Phase-1 (auth, appsCode, refresh).
 */
import axiosInstance from '../../app/utils/axios'

export const http = axiosInstance
